export const free_spin_page_win = {
	FREE_SPIN_WIN_TITLE: {
		value: 'IN GIFTED FREE SPINS YOU HAVE WON',
		config: {
			fill: '#F1E5B5',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28,
			wordWrap: true,
			wordWrapWidth: 300,
			align: 'center'
		}
	},
	FREE_SPIN_TOTAL_AMOUNT: {
		value: '',
		config: {
			fill: ['#EF9904', '#dd741d'],
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 70
		}
	},
	FREE_SPIN_TOTAL_TEXT: {
		value: 'TOTAL',
		config: {
			fontFamily: 'Japanese',
			fontSize: 60,
			letterSpacing: 1,
			fill: '#F1E5B5'
		}
	},
	FREE_SPIN_BTN: {
		value: 'OK',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	}
};
